import React, {useState} from 'react';
import "../../../css/layout/sidebar.css";
import { ReactComponent as Debt } from '../../../resources/icons/sidebar/debt3.svg';
import SidebarRowArrow from './sidebarRow';
import SidebarAllCountryList from './pages/SidebarAllCountryList';

const SidebarDebtRow = ({parentExpanded}) => {
    const [color, SetColor] = useState("#909090");
    const [clicked, SetClicked] = useState(parentExpanded);
    const onClickFunc = () =>{
        SetClicked(!clicked);
    }
    if(!clicked){
        return (
            <div className='sidemenu-item-box'>
                <a href="/DebtClockNavigation" style={{all: "initial"}}>< Debt fill={color} stroke={color}  className='sidebar-menu-svg' width="30px" /></a>
            <div onClick={onClickFunc} className='sidebar-menu-items-div'>
            <p className='sidebar-menu-items-p'>Debt</p>
            <SidebarRowArrow isClicked={clicked}/>
            </div>
            </div>
            
        );
    }
    return (
        <div className='sidemenu-item-box'>
            <a href="/DebtClockNavigation" style={{all: "initial"}}>< Debt fill={color} stroke={color}  className='sidebar-menu-svg' width="30px"/></a>
            <div onClick={onClickFunc} className='sidebar-menu-items-div'>
            <p className='sidebar-menu-items-p'>Debt</p>
            <SidebarRowArrow isClicked={clicked}/>
            </div>
        <SidebarAllCountryList path={"/DebtClock"}/>
        </div>
        
    );
}

export default SidebarDebtRow;